import { render, staticRenderFns } from "./manage-activity.component.vue?vue&type=template&id=0d54c1ce&scoped=true&"
import script from "./manage-activity.component.vue?vue&type=script&lang=ts&"
export * from "./manage-activity.component.vue?vue&type=script&lang=ts&"
import style0 from "./manage-activity.component.vue?vue&type=style&index=0&id=0d54c1ce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d54c1ce",
  null
  
)

export default component.exports